import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

import '../../assets/css/CollectionMainInfoPageVer.css'

import { AND, OR, NOT } from '../../config';
import Footer from "../../components/Footer";
import CollectionMaininfoPageCell from "../../components/CollectionMaininfoPageCell";

import TFAILogoMain from '../../assets/images/TFAI-logo-main.svg'
import bgPic1 from '../../assets/images/pic-sCR01b.jpg'

const Film = () => {
    const searchWord = localStorage.getItem('keyWord')// 查詢關鍵字
    const itemData = JSON.parse(localStorage.getItem('itemData'));
    const printPageRef = useRef();
    
    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });
    
    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
          const sortedArray = searchArray.sort((a, b) => b.length - a.length);
          const regex = new RegExp(sortedArray.join('|'), 'gi');
          // Matches array needed to maintain the correct letter casing
          const matches = [...text.matchAll(regex)];
          return text.split(regex).map((part, index) => (
            `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
          )).join('');
        }
        return text;
    };

    const conditionCheck = (value)=>{        
        if(value){
            let target = value.replace(/\s/g,"")
            if(target === '' || target === '無標註'){
                return false
            } else{
                return true
            }
        } else{
            return false
        }
    }

    const createIDInfo = (print) => {
        return itemData && conditionCheck(itemData.原始藏品編號) ?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">  
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"原始藏品編號 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.原始藏品編號) }} />
                        </div>
                    </div>
                </div>
            </div>
        :null
    }
    const createPublishInfo = (print) => {
        return itemData && (conditionCheck(itemData.出品公司) || conditionCheck(itemData.製作人))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.出品公司) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"出品公司 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.出品公司) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.製作人) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"出品人 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData?<div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.製作人) }} /> :""}
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createContributor = (print) => {
        return (itemData.職員表 && Object.keys(itemData.職員表).length>0) || (itemData.演員表 && Object.keys(itemData.演員表).length>0)?
            <div className="CollectionMainInfoMajorArea">
                {itemData.職員表 && Object.keys(itemData.職員表).length>0 ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"職員表 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                            {Object.keys(itemData.職員表).map((staff,index)=>{
                                return staff && 
                                    <div style={{margin:'5px'}} key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight(staff+" : "+itemData.職員表[staff]) }}/> 
                            })}
                            </CollectionMaininfoPageCell>
                            </div>                                                
                        </div>
                    </div>
                :null}
                {itemData.演員表 && Object.keys(itemData.演員表).length>0 ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"演員表 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                            {Object.keys(itemData.演員表).map((actor,index)=>{
                                return <div style={{margin:'5px'}} key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight(actor) }}/>
                            })}
                            </CollectionMaininfoPageCell>
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createDateInfo = (print) => {
        return itemData && conditionCheck(itemData.出品日期) ?
            <div className="CollectionMainInfoMajorArea">
                {itemData && conditionCheck(itemData.出品日期) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"出品日期 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.出品日期) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createSpecInfo = (print) => {
        return itemData && (conditionCheck(itemData.片長時間)||conditionCheck(itemData.膠片規格)||conditionCheck(itemData.乳劑類別)||conditionCheck(itemData.影片色彩))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.片長時間) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"片長時間 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.片長時間) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.膠片規格) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"膠片規格 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.膠片規格) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.乳劑類別) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"乳劑類別 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.乳劑類別) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.影片色彩) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"影片色彩 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.影片色彩) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createLanguageInfo = (print) => {
        return itemData && (conditionCheck(itemData['發音/配音'])||conditionCheck(itemData.字幕))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData['發音/配音']) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"發音/配音 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData['發音/配音']!==null?itemData['發音/配音'].replace(';','；'):itemData['發音/配音']}
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.字幕) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"字幕 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData.字幕!==null?itemData.字幕.replace(';','；'):itemData.字幕}
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }

    const getTime = () => {
        let d = new Date()
        return d.toLocaleString()
    }

    return (<>
        <div className="TFAI-box">
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic"><img alt="headPic" src={bgPic1} /></div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <Link to="/"><img src={TFAILogoMain} alt="TFAI logo" className="img-fluid"/></Link>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>膠片類藏品</span></h1>
                    </div>
                </div>
                <div className="ctn-area">
                    <div className="data-header row">  
                        <div className="col-12 col-md-7 col-lg-6">
                            <h2><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} /></h2>
                        </div>
                        <div className="col-12 col-md-5 col-lg-4 d-flex align-items-end share-links">
                            <div className="media-share">        
                                <ReactToPrint
                                    trigger={()=>                         
                                        <svg className="bi bi-printer-fill" viewBox="0 0 16 16">
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                        </svg>
                                    }
                                    content={()=>printPageRef.current}
                                />                    
                            </div>  
                        </div>
                    </div>
                    <div className="data-body row">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="px-1" >
                                {createIDInfo()}
                                {createPublishInfo()}
                                {createContributor()}
                                {createDateInfo()}
                                {createSpecInfo()}
                                {createLanguageInfo()}
                            </div>
                        </div>
                        <div className="data-img col-12 col-md-5 col-lg-4 ">
                            <aside>
                                <span>典藏單位</span>
                                <p>國家電影及視聽文化中心</p>
                            </aside>
                            <aside>                            
                                <p style={{marginBottom:'2px',color:'black',fontWeight:'bolder'}}>
                                    藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫
                                    <a href="https://www.tfai.org.tw/downloads/rent">資料借出使用申請單</a>
                                    ，向本中心提出申請。
                                </p>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>   
            
            <div style={{ display: "none" }}>
                <div className="CollectionMainInfoMainBodyPrintPage" ref={printPageRef}>
                    <div>
                        <div style={{display:'flex'}}>
                            <div style={{position:'relative',width:'220px'}}>
                                <div style={{position:'absolute',bottom:'0px',fontSize:'12px'}}>
                                    {"國家電影及視聽文化中心 藏品檢索系統"}
                                </div>
                            </div>
                            <div>
                                <img alt="logo" src={TFAILogoMain}/>
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex'}}>
                        <div style={{width:'98%', margin:'1vw 1vw 0 1vw', fontSize:'20px'}}>
                            <div className="CollectionMainTitle" style={{borderBottom:'1px solid gray'}}>
                                <div className="CollectionMainInfoRow">
                                    <div className="MovieTitle" style={{fontSize:'20px'}}>
                                        <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} />
                                    </div>
                                </div>
                                {conditionCheck(itemData.副標題) ?
                                    <div className="CollectionMainInfoRow">
                                        <div className="CollectionMainInfoRowTitlePageVer"  style={{fontSize:'12px'}}>{"其他片名 "}</div>
                                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:'12px'}}>
                                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.副標題) }} />
                                        </div>
                                    </div>
                                :null}
                            </div>
                        </div>
                    </div>
                    <div className="CollectionMainInfoTableBody">                 
                        <div className='CollectionMainInfoTableColumnPrint'>
                            <div >
                                {createIDInfo(true)}
                                {createPublishInfo(true)}
                                {createContributor(true)}
                                {createDateInfo(true)}
                                {createSpecInfo(true)}
                                {createLanguageInfo(true)}
                            </div>           
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="MovieRowTitle" style={{fontSize:'14px'}}>{"管理權"}</div>
                            </div>
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="CollectionMainInfoRowTitlePageVer" style={{width:'100%',fontSize:'12px'}}>{"國家電影及視聽文化中心"}</div>
                            </div>
                        </div>
                    </div>
                    <div style={{float:'right',paddingBottom:'50px'}} >
                        <div>
                            <div style={{display:'flex',fontSize:'12px'}}>
                                <div>列印時間 ：</div>
                                <div>{getTime()}</div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>  

            <Footer />
        </div>
    </>)
};

export default Film;